import { render, staticRenderFns } from "./IconShield.vue?vue&type=template&id=1652098d"
import script from "./IconShield.vue?vue&type=script&lang=js"
export * from "./IconShield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports